import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'NewPremiumItemsLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'e28a262d-367b-4074-95f9-c1ea78337348',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'ed6c4c04-bdc4-4857-a3b5-c7db364af637',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 550,
        y: 300
      },
      width: 1100,
      height: 600,
      leftWidth: 94,
      topHeight: 105,
      rightWidth: 105,
      bottomHeight: 105,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'niceslice_popup',
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: '0b4c6c00-8850-4582-b730-19de2cb525e7',
      type: 'Sprite',
      name: 'titleBg',
      nameSpace: '',
      className: '',
      x: 0,
      y: -248,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: '11cff2aa-e98c-492d-92ad-86a55f4c03ba',
      type: 'Sprite',
      name: 'premiumTab',
      nameSpace: '',
      className: '',
      x: -412,
      y: -316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_tab',
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: '216834e9-af5d-438a-9c82-8cc0651cffdf',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -121,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'NewItemsInfo',
      localize: true,
      maxWidth: 687,
      maxHeight: 106,
      maxFontSize: 71,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -6,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: '10076e0e-446c-4d0b-b969-97987934deb2',
      type: 'Container',
      name: '',
      nameSpace: 'itemsContainer',
      className: '',
      x: 0,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: 'd6940357-b944-4865-9872-9b0128ed15c1',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 494,
      y: -244,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: 'e66f6c02-9f87-4e7a-aef2-5dc3f2a3c4f3',
      type: 'Sprite',
      name: 'continueButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'e28a262d-367b-4074-95f9-c1ea78337348',
      data: ''
    },
    {
      id: '47ecb7a6-fec0-473f-80ea-a9a863deece6',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'NewItems',
      localize: true,
      maxWidth: 360,
      maxHeight: 68,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9A3234',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0b4c6c00-8850-4582-b730-19de2cb525e7',
      data: ''
    },
    {
      id: 'b2d2ecb1-9bcf-4adb-996b-12661aeeaa75',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_premium',
      parent: '11cff2aa-e98c-492d-92ad-86a55f4c03ba',
      data: ''
    },
    {
      id: '723bf1a2-7c7b-4c60-953e-58e822919a3a',
      type: 'Sprite',
      name: 'item_0',
      nameSpace: 'item[]',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_bg',
      parent: '10076e0e-446c-4d0b-b969-97987934deb2',
      data: ''
    },
    {
      id: 'b8111e27-6c4a-4fba-945f-5535b7bf1fdb',
      type: 'Sprite',
      name: 'item_1',
      nameSpace: 'item[]',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_bg',
      parent: '10076e0e-446c-4d0b-b969-97987934deb2',
      data: ''
    },
    {
      id: '4a1f8aa6-5c8b-49b8-bc80-0994d0a2d773',
      type: 'Sprite',
      name: 'item_2',
      nameSpace: 'item[]',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_bg',
      parent: '10076e0e-446c-4d0b-b969-97987934deb2',
      data: ''
    },
    {
      id: '6854ac95-1bb5-4194-a51f-7bd93cde8385',
      type: 'Sprite',
      name: 'item_3',
      nameSpace: 'item[]',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_bg',
      parent: '10076e0e-446c-4d0b-b969-97987934deb2',
      data: ''
    },
    {
      id: '9bae2105-970a-4c71-8474-4d6cd0ea086d',
      type: 'Sprite',
      name: 'item_4',
      nameSpace: 'item[]',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'new_items_bg',
      parent: '10076e0e-446c-4d0b-b969-97987934deb2',
      data: ''
    },
    {
      id: '1d6288dc-6dc0-4aac-8fe9-f1755c780237',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#187630',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e66f6c02-9f87-4e7a-aef2-5dc3f2a3c4f3',
      data: ''
    },
    {
      id: '588a8c19-7035-4fef-88b2-6dead9db63e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: '723bf1a2-7c7b-4c60-953e-58e822919a3a',
      data: ''
    },
    {
      id: '2885f703-c6db-4623-aad1-e3b2c71e0d18',
      type: 'Sprite',
      name: 'itemThumb',
      nameSpace: '',
      className: '',
      x: 89,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'thumbnail',
      parent: '723bf1a2-7c7b-4c60-953e-58e822919a3a',
      data: ''
    },
    {
      id: 'cb57035e-cc4b-41ab-b460-ac56af2541f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: 'b8111e27-6c4a-4fba-945f-5535b7bf1fdb',
      data: ''
    },
    {
      id: 'd7616429-83bc-447d-ab0a-f916b69de117',
      type: 'Sprite',
      name: 'itemThumb',
      nameSpace: '',
      className: '',
      x: 89,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'thumbnail',
      parent: 'b8111e27-6c4a-4fba-945f-5535b7bf1fdb',
      data: ''
    },
    {
      id: '0e4b22d8-e654-4923-b546-039dcfe4d05f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: '4a1f8aa6-5c8b-49b8-bc80-0994d0a2d773',
      data: ''
    },
    {
      id: 'c8b9fd1c-e1df-4032-a04d-b481f517db2b',
      type: 'Sprite',
      name: 'itemThumb',
      nameSpace: '',
      className: '',
      x: 89,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'thumbnail',
      parent: '4a1f8aa6-5c8b-49b8-bc80-0994d0a2d773',
      data: ''
    },
    {
      id: '2c4919ee-940c-4dc4-abe5-b676dd83a064',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: '6854ac95-1bb5-4194-a51f-7bd93cde8385',
      data: ''
    },
    {
      id: '43107b74-181c-47af-b18c-02c8b4c7d12c',
      type: 'Sprite',
      name: 'itemThumb',
      nameSpace: '',
      className: '',
      x: 89,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'thumbnail',
      parent: '6854ac95-1bb5-4194-a51f-7bd93cde8385',
      data: ''
    },
    {
      id: '79938875-596d-46e6-9046-dd5e2f8ad9c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: -85,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_bg',
      parent: '9bae2105-970a-4c71-8474-4d6cd0ea086d',
      data: ''
    },
    {
      id: 'd0e0272d-7448-4ae8-ace6-234cbb3a4a46',
      type: 'Sprite',
      name: 'itemThumb',
      nameSpace: '',
      className: '',
      x: 89,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'thumbnail',
      parent: '9bae2105-970a-4c71-8474-4d6cd0ea086d',
      data: ''
    },
    {
      id: '75c38b0e-ff40-42b7-b360-5f4d8de6379d',
      type: 'Sprite',
      name: 'taskSprite',
      nameSpace: '',
      className: '',
      x: -2,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_small',
      parent: '588a8c19-7035-4fef-88b2-6dead9db63e3',
      data: ''
    },
    {
      id: 'e6121582-3706-4df5-b8a3-ecdffaad097a',
      type: 'Sprite',
      name: 'taskSprite',
      nameSpace: '',
      className: '',
      x: -2,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_small',
      parent: 'cb57035e-cc4b-41ab-b460-ac56af2541f3',
      data: ''
    },
    {
      id: '4ad6d2ba-ca6b-40e7-8fb3-46eff8f4814d',
      type: 'Sprite',
      name: 'taskSprite',
      nameSpace: '',
      className: '',
      x: -2,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_small',
      parent: '0e4b22d8-e654-4923-b546-039dcfe4d05f',
      data: ''
    },
    {
      id: 'e8258e3d-4241-4baa-b4f7-c0d4dbbd1378',
      type: 'Sprite',
      name: 'taskSprite',
      nameSpace: '',
      className: '',
      x: -2,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_small',
      parent: '2c4919ee-940c-4dc4-abe5-b676dd83a064',
      data: ''
    },
    {
      id: '326352d7-11a6-4d71-81c7-5ed83625e4ea',
      type: 'Sprite',
      name: 'taskSprite',
      nameSpace: '',
      className: '',
      x: -2,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'reply_task_small',
      parent: '79938875-596d-46e6-9046-dd5e2f8ad9c1',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class NewPremiumItemsLayout {
  static raw = raw;
  root: PIXI.Container
  bg: PIXI.NineSlicePlane
  titleBg: PIXI.Sprite
  premiumTab: PIXI.Sprite
  closeButton: PIXI.Sprite
  continueButton: PIXI.Sprite
  itemsContainer: {
    item_0: PIXI.Sprite
    item_1: PIXI.Sprite
    item_2: PIXI.Sprite
    item_3: PIXI.Sprite
    item_4: PIXI.Sprite
    item: ({
      taskSprite: PIXI.Sprite
      itemThumb: PIXI.Sprite
      children: (PIXI.Sprite)[]
    })[]
    children: (PIXI.Sprite)[]
  }

  constructor() {
    populate(this, raw);
  }
}
